import { Component, OnInit } from '@angular/core';

import packageJSON from '../../../../../../package.json';
import { INFO_EMAIL } from '../../../../../common/models/constants';
import { MainEventService } from '../../../../../common/shared/main-event.service';
import { CacheService } from '../../core/services/cache.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  currentYear: number = new Date().getFullYear();
  contactEmail: string = INFO_EMAIL;
  lang: string = this.cache.lang;
  // Languages with legal documents available under assets/documents/{lang}/
  private readonly supportedDocLangs = ['en', 'es'];
  get docLang(): string { return this.supportedDocLangs.includes(this.lang) ? this.lang : 'en'; }
  version = packageJSON.version;
  company = '';
  companyId = 'B20458642'; // Legal ID de GDAR

  // Cambios footer gdar
  terms = '/terms-and-conditions.pdf';
  gdarConfig = {
    contactEmail: 'info@gdar.es',
    terms: '/terms-and-conditions-gdar.pdf',
  };

  constructor(private cache: CacheService) {
  };

  ngOnInit() {
    MainEventService.localeChanged.subscribe(() => this.lang = this.cache.lang);

    const pathname = window.location.pathname;
    const pathParts = pathname.split('/').filter(p => p);

    this.company = pathParts.length > 0 ? pathParts[0] : '';
    if (this.company === 'gdar') {
      this.contactEmail = this.gdarConfig.contactEmail;
      this.terms = this.gdarConfig.terms;
    }
    this.cache.getUser().subscribe(user => this.updateFooterState(user));
  }

  updateFooterState(user?: any) {
    if (user?.organization?.legalId === this.companyId || (!user && this.company === 'gdar')) {
      this.contactEmail = this.gdarConfig.contactEmail;
      this.terms = this.gdarConfig.terms;
    }
  }

}
